import './list.sass'
import 'rc-collapse/assets/index.css';

import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';

import Title from 'components/track-events/title/Title';
import Accordion from 'components/track-events/accordion/Accordion';
import ContentLoader from 'controls/content-loader/ContentLoader';
import TrackComment from 'components/track-events/track-comment/TrackComment';

import request from 'actions/request';

class List extends React.Component {
  componentDidMount() {
    if ((this.props.pending === null)
      || ((this.props.pending === false)
        && (this.props.track.id !== this.props.trackId)
      )
    ) {
      this.props.request(
        ['tracks', 'getInfo'],
        'get',
        'TRACK',
        { trackId: this.props.trackId }
      );
    }

    if ((this.props.trackEventsPending === null)
      || ((this.props.trackEventsPending === false)
        && (this.props.trackEvents.id !== this.props.trackId)
      )
    ) {
      this.props.request(
        ['trackEvents', 'get'],
        'get',
        'TRACK_EVENTS',
        { trackId: this.props.trackId }
      );
    }
  }

  buildList() {
    if ((this.props.trackEventsPending !== false)
      || (this.props.trackEvents.id === this.props.trackId)
    ) {
      return <ContentLoader/>
    }

    if (this.props.isProcessed === false) {
      return <div className='track-events-list__not-processed'>
        <Translate value='trackEvents.list.processingNotPerformed'/>
      </div>;
    }

    if (Object.keys(this.props.trackEvents.items).length === 0) {
      return <div className='track-events-list__not-processed'>
        <Translate value='trackEvents.list.noEvents'/>
      </div>;
    }

    return <Accordion
      items={ this.props.trackEvents.items }
      trackId= { this.props.trackId }
    />;
  }

  buildBody() {
    if (this.props.pending !== false) {
      return <ContentLoader/>
    }

    return this.buildList();
  }

  bulidTitle() {
    if (this.props.track.id === this.props.trackId) {
      return <Title track={ this.props.track.data }/>;
    }

    return '';
  }

  render() {
    return (
      <div className='track-events-list'>
        { this.bulidTitle() }
        <TrackComment trackId={ this.props.trackId }/>
        { this.buildBody() }
      </div>
    );
  }
}

List.propTypes = {
  trackId: PropTypes.number.isRequired,
  track:  PropTypes.shape({
    recorderName: PropTypes.string,
    vehicle: PropTypes.string,
    name: PropTypes.string,
    origin: PropTypes.string,
    destination: PropTypes.string,
    startedAtFormatted: PropTypes.string,
    recorderName: PropTypes.string,
    aditionalInfo: PropTypes.object
  }).isRequired,
  pending: PropTypes.oneOf([true, false, null]),
  trackEventsPending: PropTypes.oneOf([true, false, null]),
  isProcessed: PropTypes.oneOf([true, false, null])
};

function mapStateToProps(state) {
  return {
    pending: state.track.pending,
    track: state.track,
    trackEventsPending: state.trackEvents.pending,
    isProcessed: state.trackEvents.isProcessed,
    trackEvents: state.trackEvents
  };
}

function mapDispatchToProps(dispatch) {
  return {
    request: bindActionCreators(request, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(List);
